import { Turbo } from "@hotwired/turbo-rails";
import { application } from "@controllers/application";

import MarqueeCarouselController from "@controllers/preline/carousel/marquee-carousel";

application.register("marquee-carousel", MarqueeCarouselController);

Turbo.session.drive = false;
